import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common/common'
import cardProject from './modules/cardProject/cardProject'
import login from './modules/login/login'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    common,
    cardProject,
    login
  }
})

export default store



// WEBPACK FOOTER //
// ./src/pages/GenRedOne/store/store.js